import chapterFormat from './chapter-format';

import type { ShortcodeProps } from '../interface';

export default ({ html, id, path }: ShortcodeProps) => {
  if (!html) {
    return html;
  }

  const level = path.length;
  const number = chapterFormat(path);

  const re = /<h1>(.*?)<\/h1>/g;
  const replaceValue = `<h${level} id="${id}">${number} $1</h${level}>`;

  return html.replace(re, replaceValue);
};
